import cookie from "js-cookie";

const getCookieFromBrowser = key => {
  return cookie.get(key);
};

const getCookieFromServer = (key, req) => {
  if (!req.headers?.cookie) {
    return undefined;
  }
  const rawCookie = req.headers.cookie
    .split(";")
    .find(c => c.trim().startsWith(`${key}=`));
  if (!rawCookie) {
    return undefined;
  }
  return rawCookie.split("=")[1];
};
const CookieService = {
  setCookie: (key, value, expires = 365, domain = undefined) => {
    if (process.browser) {
      cookie.set(key, value, {
        expires,
        path: "/",
        ...(domain && { domain })
      });
    }
  },

  removeCookie: (key, domain = undefined) => {
    if (process.browser) {
      cookie.remove(key, {
        expires: 1,
        ...(domain && { domain })
      });
    }
  },

  getCookie: (key, req) => {
    if (!req) return getCookieFromBrowser(key);
    return process.browser
      ? getCookieFromBrowser(key)
      : getCookieFromServer(key, req);
  }
};

export default CookieService;
